<dialog #dialogElement class="ds-dialog">
  <i class="ds-close" (click)="onClose()"></i>
  <header *ngIf="dialogHeaderDirective">
    <ng-content select="ui-dialog-header"></ng-content>
  </header>
  <div *ngIf="dialogBodyDirective">
    <ng-content select="ui-dialog-body"></ng-content>
  </div>
  <footer *ngIf="dialogFooterDirective">
    <ng-content select="ui-dialog-footer"></ng-content>
  </footer>
</dialog>

<ng-content></ng-content>
